import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeShipmentTerms } from './normalize';

export const fetchShipmentTerms = createProvider(api.fetchShipmentTerms)
  .andThen((res) => normalizeShipmentTerms(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
